<template>
  <div class="data-table report" style="color: #666;">
    <div class="wrap-title" style="margin-bottom:5px;">
      <div class="flex-space"></div>
      <h1 class="" style="margin: 4px 0; color: #666;">
        <span style="font-size:16px;">想定月額通信費:</span><br>
        ${{ totalCost }}
        <span v-if="totalCost > 0 && totalCost < roundCost(totalCost * 1.2)"> ~${{ roundCost(totalCost * 1.2) }}</span>
        / month
      </h1>
    </div>
    <div class="wrap-title" style="width:100%; margin-bottom:5px;">
      <div class="flex-space"></div>
      <template v-if="!isEditing">
        <el-button type="primary" size="medium" icon="el-icon-edit" @click="enterEdit">編集</el-button>
      </template>
      <template v-else>
        <el-button type="danger" size="medium" @click="cancelEdit">取消</el-button>
        <el-button type="primary" size="medium" @click="saveEdit" :disabled="hasErrors">保存</el-button>
      </template>
    </div>
    <div class="section-block" v-for="(costs, typeName) in isEditing ? editData.list : data.list" :key="typeName">
      <h1 class="section-title">{{ typeName }}</h1>
      <div class="costs-wrapper">
        <div v-for="(records, dataName) in costs" :key="typeName + '-' + dataName">
          <div class="cost-header">
            <div>
              <h3 class="section-cost">{{ dataName }}</h3>
              <h3 class="section-cost">
                ${{ costSumsByTypeAnddataName[typeName][dataName] }}
                <span  v-if="costSumsByTypeAnddataName[typeName][dataName] > 0 
                  && costSumsByTypeAnddataName[typeName][dataName] < roundCost(costSumsByTypeAnddataName[typeName][dataName] * 1.2)">
                  ~${{  roundCost(costSumsByTypeAnddataName[typeName][dataName] * 1.2) }}
                </span>
                / month
              </h3>
            </div>
            <div class="cost-table-wrapper">
              <table class="data-table-scraping">
                <thead>
                  <tr>
                    <th v-for="(column, column_index) in data.columns" :key="column.id" class="data-table-scraping-th" :class="column_index == 1 || column.sticky ? 'data-table-scraping-th-title' : ''">
                      <div class="column-label">
                        <div class="flex-column">
                          <div>{{ column.ja }}</div>
                          <div  class="column-sub">{{ column.value }}</div>
                        </div>
                      </div>
                    </th>
                    <!-- 追加ボタン -->
                    <th v-if="isEditing" class="data-table-scraping-th">
                      <div class="flex-column">追加</div>
                    </th>
                    <!-- 削除ボタン -->
                    <th v-if="isEditing" class="data-table-scraping-th">
                      <div class="flex-column">削除</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                    <tr
                      v-for="(row, index) in records"
                      :key="index"
                      :class="[
                        isEditing ? 'editing-row' : '',
                        row.delete_flag === 1 ? 'deleted-row' : ''
                      ]"
                    >
                      <td class="data-table-scraping-td">
                        <template v-if="isEditing">
                          <div style="display: flex; flex-direction: column;">
                            <el-input 
                              size="small" 
                              v-model="row.follower_min" 
                              @blur="validateRow(row, typeName, dataName, index)"
                              type="number" 
                              :class="{ 'is-error': row.errors && (row.errors.follower_min || row.errors.duplicate) }"
                              :disabled="row.follower_min === 0 || row.delete_flag === 1"
                            />
                            <small v-if="row.errors && row.errors.follower_min" style="color: #ff4d4f; font-size: 10px;">
                              0以上の整数を入力してください
                            </small>
                            <small v-if="row.errors && row.errors.duplicate" style="color: #ff4d4f; font-size: 10px;">
                              すでに設定されています
                            </small>
                          </div>
                        </template>
                        <template v-else>
                          {{ row.follower_min.toLocaleString() }}
                        </template>
                      </td>
                      <td class="data-table-scraping-td">
                        <template v-if="isEditing">
                          <div style="display: flex; flex-direction: column;">
                            <el-input 
                              size="small" 
                              v-model="row.interval_day" 
                              @blur="validateRow(row, typeName, dataName, index)"
                              type="number" 
                              :class="{ 'is-error': row.errors && (row.errors.interval_day || row.errors.calculation_failed) }"
                              :disabled="row.delete_flag === 1"
                            />
                            <small v-if="row.errors && row.errors.interval_day" style="color: #ff4d4f; font-size: 10px;">
                              0以上、180以下の数字を入力してください
                            </small>
                            <small v-if="row.errors && row.errors.calculation_failed" style="color: #ff4d4f; font-size: 10px;">
                              計算時にエラーが発生しました
                            </small>
                          </div>
                        </template>
                        <template v-else>
                          {{ row.interval_day }}
                        </template>
                      </td>
                      <td class="data-table-scraping-td column">{{ row.setting_at }}</td>
                      <td v-if="isEditing" class="data-table-scraping-td">
                        <el-button 
                          type="success" 
                          icon="el-icon-plus" 
                          circle 
                          @click="addRow(typeName, dataName, index)" 
                          :disabled="row.delete_flag === 1"
                          style="width:24px; height:24px; padding:0; font-size:12px;">
                        </el-button>
                      </td>
                      <td v-if="isEditing" class="data-table-scraping-td">
                        <!-- 削除されていない行 -->
                        <el-button
                          v-if="row.follower_min !== 0 && row.delete_flag !== 1"
                          type="danger"
                          icon="el-icon-minus"
                          circle
                          @click="removeRow(typeName, dataName, index)"
                          :disabled="row.delete_flag === 1"
                          style="width:24px; height:24px; padding:0; font-size:12px;"
                        />
                        <!-- 削除された行の復元ボタン -->
                        <el-button
                          v-else-if="row.delete_flag === 1"
                          type="primary"
                          icon="el-icon-refresh-left"
                          circle
                          @click="restoreRow(typeName, dataName, index)"
                          style="width:24px; height:24px; padding:0; font-size:12px;"
                        />
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list_column from "@/components/list/list_column.vue";

const root = process.env.VUE_APP_API;
const loadAPI = root + "/api/admin/scraping_setting_load";
const editAPI = root + "/api/admin/scraping_setting_edit";
const calculateAPI = root + "/api/admin/scraping_setting_calculate";

export default {
  name: "adminList",
  props: {
    type: {
      data: Object,
      type: String,
      required: true
    },
    sns_type: {
      type: String,
      required: true
    },
  },
  components: {
  },
  data() {
    return {
      data: [],
      count: 0,
      limit: 50,
      sort_order: true,
      sort_key: "",
      currentPage: 1,
      filter: {
        column: "",
        type: "rlike",
        value: "",
      },
      loading: false,
      clicked: -1,
      edit: "",
      edit_list: -1,
      edit_item: -1,
      drawer: false,
      timestamp: 9999999999,
      processing: false,
      admin_regist_modal: false,
      registColumns: [],
      tableName: "",
      currentTab: "",
      isEditing: false,
      editData: {},
      hasErrors: false, // ← ボタンのdisabledに使う
    };
  },
  computed: {
    list_column() {
      return list_column
    },
    token() {
      return this.$store.state.token;
    },
    filterOn() {
      if (this.filter.column && this.filter.type && this.filter.value) {
        return true;
      } else {
        return false;
      }
    },
    // 全体のコスト合計
    totalCost() {
      const costMap = this.costSumsByTypeAnddataName;
      if (!costMap || typeof costMap !== 'object') return 0;

      const sum = Object.values(costMap)
        .flatMap((costs) => (costs && typeof costs === 'object' ? Object.values(costs) : []))
        .reduce((sum, val) => sum + val, 0);

      return Math.round(sum * 1000) / 1000; // 小数点第2位に丸める
    },
    // dataNameごとの合計（typeName → dataName → 合計）
    costSumsByTypeAnddataName() {
      const result = {};
      const dataList = this.isEditing ? this.editData?.list : this.data?.list;

      if (!dataList || typeof dataList !== 'object') return result;

      Object.entries(dataList).forEach(([typeName, costGroup]) => {
        result[typeName] = {};
        Object.entries(costGroup || {}).forEach(([dataName, records]) => {
          const sum = (records || []).reduce((acc, row) => {
            return acc + (row.delete_flag ? 0 : (typeof row.total_cost === 'number' ? row.total_cost : 0));
          }, 0);
          result[typeName][dataName] = Math.round(sum * 1000) / 1000; // 小数点第2位に丸める
        });
      });

      return result;
    },
  },
  mounted() {
    this.timeNow();
    this.load();
    setInterval(this.timeNow, 1000);
  },
  methods: {
    load(not_scroll) {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("sns_type", this.sns_type);
      this.axios
        .post(loadAPI, params)
        .then((response) => {
          if (response.data.status === "OK") {
            this.data = response.data.data;
          } else {
            this.$message({
              message: "エラーが発生しました",
              type: "error",
              offset: 7,
              showClose: true,
            });
            console.error("表示エラー:",  response.data.message);
          }
          this.loading = false;
          if (!not_scroll) {
            this.scrollTop();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    enterEdit() {
      // 編集用データ作成
      this.editData = JSON.parse(JSON.stringify(this.data));

      // 各行に errors: {} を付与
      Object.values(this.editData.list).forEach((costGroup) => {
        Object.values(costGroup).forEach((records) => {
          records.forEach((row) => {
            row.errors = {}; // エラー追跡用フィールドを初期化
            row.original_row = JSON.parse(JSON.stringify(row)); // 元データを保持
          });
        });
      });

      this.isEditing = true;
    },
    cancelEdit() {
      this.isEditing = false;
      this.editData = {};
    },
    saveEdit() {
      // エラーがある場合はNG
      if (this.hasValidationErrors) return;

      // 編集後のデータをまとめる
      const payload = {
        list: [],
      };

      Object.values(this.editData.list).forEach((costGroup) => {
        Object.values(costGroup).forEach((records) => {
          records.forEach((row) => {
            const isNew = !row.id;
            const isEmpty = (row.follower_min === '' || row.follower_min === null)
            && (row.interval_day === '' || row.interval_day === null);
            if ((isNew && isEmpty) || (isNew && row.delete_flag === 1)) {
              return; // 両方未入力の新規行・新規かつ削除扱い → APIに送らない
            }

            payload.list.push({
              id: row.id || null, // nullの場合は新規作成
              type_id: row.type_id,
              sns_type: row.sns_type,
              data_type: row.data_type,
              follower_min: Number(row.follower_min),
              interval_day: Number(row.interval_day),
              setting_at: row.setting_at || null, // nullの場合は新規作成
              delete_flag: row.delete_flag || 0, // nullの場合は削除しない
              edit_flag: (row.original_row && (
                Number(row.follower_min) !== Number(row.original_row.follower_min) ||
                Number(row.interval_day) !== Number(row.original_row.interval_day)
              )) ? 1 : 0, // 変更がある場合は1
            });
          });
        });
      });

      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("list", JSON.stringify(payload.list));

      this.axios
        .post(editAPI, params)
        .then((response) => {
          if (response.data.status === "OK") {
            this.load(true);
            this.isEditing = false;
            this.editData = {};
            this.$message({
              message: "保存しました",
              type: "success",
              offset: 7,
              showClose: true,
            });
          } else {
            this.$message({
              message: "保存に失敗しました",
              type: "error",
              offset: 7,
              showClose: true,
            });
            console.error("保存エラー:", response.data.message || "保存に失敗しました");
          }
        })
        .catch((error) => {
          console.error("保存エラー:", error);
          this.$message.error("保存処理中にエラーが発生しました。");
        });
    },
    addRow(typeName, dataName, index) {
      const currentRow = this.editData.list[typeName][dataName][index];
      const newRow = {
        id: null,
        follower_min: '',
        interval_day: '',
        setting_at: null, // 空欄のまま or 現在時刻などでも可
        type_id: currentRow.type_id,  // コピー
        sns_type: currentRow.sns_type,  // コピー
        data_type: currentRow.data_type,  // コピー
        cost: currentRow.cost,  // コピー
        delete_flag: 0,
        errors: { follower_min: false, interval_day: false }
      };
      this.editData.list[typeName][dataName].splice(index + 1, 0, newRow);
    },
    removeRow(typeName, dataName, index) {
      const row = this.editData.list[typeName][dataName][index];

      const isNew = !row.id;
      if (isNew) {
        // 新規追加された行 → 完全削除扱い（非表示、APIに送らない）
        this.$set(row, 'delete_flag', 1);
      } else {
        // 既存行 → 値を original_row に戻してから、削除フラグを立てる（編集した値で登録して削除されることを防ぐため）
        const original = row.original_row;
        for (const key in original) {
          this.$set(row, key, original[key]);
        }
        this.$set(row, 'delete_flag', 1);
      }
    },
    restoreRow(typeName, dataName, index) {
      const row = this.editData.list[typeName][dataName][index];

      // 元の値に戻す（original_row から復元）
      if (row.original_row) {
        for (const key in row.original_row) {
          this.$set(row, key, row.original_row[key]);
        }
      }

      // 削除フラグ解除
      this.$set(row, 'delete_flag', 0);
    },
    checkValidationErrors() {
      const data = this.editData?.list || {};
      for (const costGroup of Object.values(data)) {
        for (const records of Object.values(costGroup)) {
          for (const row of records) {
            if (row.delete_flag) continue;
            if (
              row.errors?.follower_min ||
              row.errors?.interval_day ||
              row.errors?.duplicate ||
              row.errors?.calculation_failed
            ) return true;
          }
        }
      }
      return false;
    },
    validateRow(row, typeName, dataName, index) {
      if (!row.errors) {
        this.$set(row, 'errors', {});
      }
      // フォロワー下限
      const followerMin = Number(row.follower_min);
      // 初期から0の場合以外はバリデーション
      if (row.original_row?.follower_min !== 0) {
        this.$set(
          row.errors, 'follower_min',
          row.follower_min === '' || row.follower_min === null || isNaN(followerMin) || !Number.isInteger(followerMin) || followerMin === 0
        );
      }

      // 重複チェック（同じ sns_type, data_type, follower_min が他にもあるか）
      const allRows = this.editData.list;
      let isDuplicate = false;

      for (const [otherTypeName, costGroup] of Object.entries(allRows)) {
        for (const [otherDataName, records] of Object.entries(costGroup)) {
          // ⚠️ data_type が一致しない場合はスキップ
          if (otherDataName !== dataName || otherTypeName !== typeName) continue;

          for (let i = 0; i < records.length; i++) {
            const other = records[i];
            if (i === index) continue; // 自分自身はスキップ
            if (other.delete_flag === 1) continue; // 削除済みは除外

            // sns_type, data_type, follower_min が一致していたら重複
            if (
              other.sns_type === row.sns_type &&
              other.data_type === row.data_type &&
              Number(other.follower_min) === followerMin
            ) {
              isDuplicate = true;
              break;
            }
          }

          if (isDuplicate) break;
        }

        if (isDuplicate) break;
      }
      this.$set(row.errors, 'duplicate', isDuplicate);

      // 更新頻度（日）
      const intervalDay = Number(row.interval_day);
      this.$set(row.errors, 'interval_day',
        row.interval_day === '' || row.interval_day === null || isNaN(intervalDay) || intervalDay <= 0 || intervalDay > 180
      );

      // 値が変更されていて、かつバリデーションOKな場合のみ再計算
      const isNew = !row.id && row.errors.follower_min === false && row.errors.interval_day === false;  // 新規でどちらも入力された場合

      // エラーある場合は保存ボタン非活性
      this.hasErrors = this.checkValidationErrors();

      // エラーなしの場合再計算
      if (
        ((row.errors.follower_min === false || row.errors.follower_min === undefined) &&
        row.errors.interval_day === false && row.errors.duplicate === false 
        ) || isNew
      ) {
        this.calculateCost(row, typeName, dataName, index);
      }
    },
    calculateCost(row, typeName, dataName, index) {
      const records = this.editData.list[typeName][dataName];
      // 次のfollower_min（削除済みは無視）
      let followerMax = null;
      for (let i = index + 1; i < records.length; i++) {
        const nextRow = records[i];
        if (
          nextRow &&
          nextRow.delete_flag !== 1 &&
          nextRow.follower_min !== '' &&
          nextRow.follower_min !== null
        ) {
          followerMax = Number(nextRow.follower_min);
          break;
        }
      }

      // 編集後のデータをまとめる
      const payload = {
        type_id: row.type_id,
        sns_type: row.sns_type,
        data_type: row.data_type,
        cost: Number(row.cost),
        follower_min: Number(row.follower_min),
        interval_day: Number(row.interval_day),
      };

      const params = new URLSearchParams();
      if (followerMax !== null) {
        params.append("follower_max", followerMax);
      }
      params.append("list", JSON.stringify(payload));
      params.append("sns_type", this.sns_type);
      
      this.axios
        .post(calculateAPI, params)
        .then((response) => {
          if (response.data.status === "OK" && typeof response.data.cost === 'number') {
            this.$set(row, 'total_cost', response.data.cost);
          } else {
            console.error("費用計算エラー:",  response.data.message);
            this.$set(row, 'error_message', response.data.message);
            this.$set(row.errors, 'calculation_failed', true);
            this.hasErrors = this.checkValidationErrors();
          }
        })
        .catch((error) => {
          console.error("費用計算エラー:", error);
        });
    },
    scrollTop() {
      var itemArea = document.getElementById("data-table");
      itemArea.scrollTop = 0;
    },
    timeNow() {
      var date = new Date();
      var timestamp = date.getTime();
      this.timestamp = Math.floor(timestamp / 1000) - 60 * 5;
    },
    roundCost(total_cost) {
      return Number(total_cost).toFixed(2);
    },
  },
  watch: {
    // サイドメニュー切り替え時のみ呼び出し
    type() {
      this.timeNow();
      this.load();
      setInterval(this.timeNow, 1000);
    }
  },
};
</script>
